import React, { useState } from "react";
import {
  TextArea,
  MyMessage,
  AddPageShell,
  AddSection,
} from "../components/Component";
import { useStaticContext } from "../../context/StaticContext";
import { getOnePrivacy } from "../../lib/sysNavigation/SysNavigation";
import { FiShield } from "react-icons/fi";

const Edit = () => {
  const { updatePrivacy } = useStaticContext();
  const privacy: any = getOnePrivacy();

  const [error, setError] = useState<any>(false);
  const [message, setErrorMessage] = useState<any>("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState<any>(false);

  const privacy_id = privacy?.privacy_id;
  const [description, setDescription] = useState<any>(privacy?.description);

  const privacyRoutes = "/privacy";

  const responses = (error: any, message: any) => {
    setError(error);
    setSuccess(!error);
    setLoading(false);
    setErrorMessage(message);
  };

  const updateOnePrivacyHandler = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    await sendDBRequest();
  };

  const sendDBRequest = async () => {
    const { status, message } = await updatePrivacy({
      id: privacy_id,
      data: { description },
    });
    if (status === 200) responses(false, message);
    else responses(true, message);
  };

  const clearMessages = () => {
    setError(null);
    setSuccess(null);
  };

  return (
    <AddPageShell
      backRoute={privacyRoutes}
      eyebrow="Settings • Privacy"
      title="Edit Privacy Policy"
      subtitle="Keep the language clear and aligned with your data practices."
      icon={<FiShield className="h-5 w-5" />}
      loading={loading}
      submitLabel="Save Changes"
      onSubmit={updateOnePrivacyHandler}
      onSubmitClick={() => {
        setError(false);
        setSuccess(false);
        setErrorMessage(null);
      }}
      message={
        <MyMessage
          error={error}
          message={message}
          success={success}
          onExpired={() => {
            setError(false);
            setSuccess(false);
          }}
          onClick={() => {
            setError(false);
            setSuccess(false);
            setErrorMessage("");
          }}
        />
      }
    >
      <AddSection title="Content" hint="Markdown is supported.">
        <TextArea
          props={{
            id: "description",
            title: "",
            type: "text",
            value: description ? description : "",
            rows: 10,
            onChange: (e: any) => {
              setDescription(e.target.value);
              clearMessages();
            },
          }}
        />
      </AddSection>
    </AddPageShell>
  );
};

export default Edit;
